<template>
  <div>
    <v-container fluid class="hyp-table-container">
      <v-row>
        <v-col cols="12" class="details-heading application-heading pull-left">
          <span>Setup Profile </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="max-height: 600px;" class="overflow-y-auto">
          <v-row>
            <v-col cols="12" class="details-heading">{{ labelType }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <span v-html="assetTypesDescription"></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-list>
                <template v-for="(selectedAssetType, i) in systemAssetTypes">
                  <v-divider
                    v-if="!selectedAssetType"
                    :key="`divider-${i}`"
                  ></v-divider>
                  <v-list-item
                    v-else
                    :key="`selectedAssetType-${i}`"
                    :value="selectedAssetType"
                    active-class="deep-green--text text--accent-4"
                  >
                    <template v-slot:default="{}">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="selectedAssetType.name"
                        ></v-list-item-title>
                        <div v-if="editedAssetId === selectedAssetType.id">
                          <v-row dense class="pt-0">
                            <v-col cols="6" class="pt-0">
                              <v-select
                                v-model="selectedAssetType.color"
                                :items="colors"
                                item-text="color"
                                item-value="hex"
                                label="Select A Color"
                                single-line
                                clearable
                              ></v-select>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <v-select
                                v-model="selectedAssetType.icon"
                                :items="icons"
                                item-text="text"
                                item-value="value"
                                label="Select An Icon"
                                single-line
                                clearable
                              >
                                <template v-slot:selection="{ item }"
                                  ><img
                                    :src="getDisplayIcon(item)"
                                    alt
                                    class="icon mr-4"
                                  />
                                  {{ item.text }}
                                </template>
                                <template v-slot:item="{ item }">
                                  <img
                                    :src="getDisplayIcon(item)"
                                    alt
                                    class="icon mr-2"
                                  />
                                  {{ item.text }}
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                        </div>
                      </v-list-item-content>

                      <v-icon
                        small
                        class="pull-left"
                        v-show="editedAssetId !== selectedAssetType.id"
                        v-on:click.prevent="toggleEdit(selectedAssetType)"
                        >mdi-pencil</v-icon
                      >
                      <v-list-item-action>
                        <v-switch
                          v-model="selectedAssetType.isActive"
                          class="event-input-toggle pa-0 ma-0 mt-1"
                          solo
                          v-show="editedAssetId !== selectedAssetType.id"
                          v-on:change="toggleState(selectedAssetType, true)"
                        ></v-switch>
                        <div
                          class="pull-right mt-0 mb-0"
                          v-show="editedAssetId === selectedAssetType.id"
                        >
                          <v-btn
                            small
                            class="btn primary"
                            @click.prevent="toggleSave(selectedAssetType)"
                          >
                            Save
                          </v-btn>
                          <v-btn
                            small
                            class="btn ml-2"
                            @click.prevent="toggleClose"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="details-heading pb-0">
              <span v-html="assetTypesCustomDescription"></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-list>
                <template v-for="(customAssetType, i) in customAssetTypes">
                  <v-divider
                    v-if="!customAssetType"
                    :key="`divider-${i}`"
                  ></v-divider>
                  <v-list-item
                    v-else
                    :key="`customAssetType-${i}`"
                    :value="customAssetType"
                    active-class="deep-green--text text--accent-4"
                  >
                    <template v-slot:default="{}">
                      <v-list-item-content>
                        <div
                          v-if="
                            editedCustomAssetId === customAssetType.assetTypeId
                          "
                        >
                          <v-row dense class="pb-0">
                            <v-col cols="12" class="pb-0">
                              <v-text-field
                                v-model="customAssetType.name"
                                size="50"
                                :ref="`asset${customAssetType.assetTypeId}`"
                              />
                            </v-col>
                          </v-row>
                          <v-row dense class="pt-0">
                            <v-col cols="6" class="pt-0">
                              <v-select
                                v-model="customAssetType.color"
                                :items="colors"
                                item-text="color"
                                item-value="hex"
                                label="Select A Color"
                                single-line
                                clearable
                                class="pt-0"
                              ></v-select>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <v-select
                                v-model="customAssetType.icon"
                                :items="icons"
                                item-text="text"
                                item-value="value"
                                label="Select An Icon"
                                single-line
                                clearable
                                class="pt-0"
                              >
                                <template v-slot:selection="{ item }"
                                  ><img
                                    :src="getDisplayIcon(item)"
                                    alt
                                    class="icon mr-4"
                                  />
                                  {{ item.text }}
                                </template>
                                <template v-slot:item="{ item }">
                                  <img
                                    :src="getDisplayIcon(item)"
                                    alt
                                    class="icon mr-2"
                                  />
                                  {{ item.text }}
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                        </div>
                        <v-list-item-title
                          v-if="
                            editedCustomAssetId !== customAssetType.assetTypeId
                          "
                          v-text="customAssetType.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-icon
                        small
                        v-show="
                          editedCustomAssetId !== customAssetType.assetTypeId
                        "
                        v-on:click.prevent="
                          toggleEditCustomAsset(customAssetType)
                        "
                        >mdi-pencil</v-icon
                      >

                      <v-list-item-action>
                        <v-switch
                          v-model="customAssetType.isActive"
                          class="event-input-toggle pa-0 ma-0 mt-1"
                          solo
                          v-show="
                            editedCustomAssetId !== customAssetType.assetTypeId
                          "
                          v-on:change="toggleState(customAssetType, true)"
                        ></v-switch>
                        <div
                          class="pull-right"
                          v-show="
                            editedCustomAssetId === customAssetType.assetTypeId
                          "
                        >
                          <v-btn
                            small
                            class="btn primary mt-4"
                            @click.prevent="toggleSave(customAssetType)"
                          >
                            Save
                          </v-btn>
                          <v-btn
                            small
                            class="btn ml-2 mt-4"
                            @click.prevent="toggleClose"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col cols="12" class="details-heading ml-4 pb-0"
              >Custom Fields</v-col
            >
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-list>
                <template v-for="(item, i) in customAssetFields">
                  <v-list-item
                    :key="`item-${i}`"
                    :value="item"
                    active-class="deep-green--text text--accent-4"
                  >
                    <template v-slot:default="{}">
                      <v-list-item-content>
                        <div v-if="editedFieldId === item.id">
                          <v-text-field
                            v-model="item.name"
                            size="50"
                            :ref="`field${item.id}`"
                            :rules="specialCharactersRule"
                          />
                        </div>
                        <v-list-item-title
                          v-text="item.name"
                          v-if="editedFieldId !== item.id"
                        ></v-list-item-title>
                      </v-list-item-content>

                      <v-icon
                        small
                        v-show="editedFieldId !== item.id"
                        v-on:click.prevent="toggleEditField(item)"
                        >mdi-pencil</v-icon
                      >
                      <v-list-item-action>
                        <v-switch
                          v-model="item.isActive"
                          class="event-input-toggle pa-0 ma-0 mt-1"
                          solo
                          v-show="editedFieldId !== item.id"
                          v-on:change="toggleState(item, false)"
                        ></v-switch>
                        <div
                          class="pull-right"
                          v-show="editedFieldId === item.id"
                        >
                          <v-btn
                            small
                            class="btn primary mt-4"
                            @click.prevent="toggleSave(item)"
                          >
                            Save
                          </v-btn>
                          <v-btn
                            small
                            class="btn ml-2 mt-4"
                            @click.prevent="toggleClose"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import uuidV4 from "uuid/v4";
import {
  DEFAULT_ASSET_TYPES,
  ASSET_TYPES_DESCRIPTION,
  ASSET_TYPES_CUSTOM_DESCRIPTION,
  ASSET_COLORS,
  ASSET_ICONS,
} from "@/common/constants/assetManagement";
import {
  getAssetTypesByUserGroup,
  getCustomFieldsByUserGroup,
} from "@/services/assetManagement/assets.service";
import { LABELS } from "@/common/constants/labels";

export default {
  name: "AssetsSetup",
  data() {
    return {
      defaultList: DEFAULT_ASSET_TYPES,
      assetTypesDescription: ASSET_TYPES_DESCRIPTION,
      assetTypesCustomDescription: ASSET_TYPES_CUSTOM_DESCRIPTION,
      assetTypes: getAssetTypesByUserGroup(),
      assetCustomFields: getCustomFieldsByUserGroup(),
      editedAssetId: "",
      editedCustomAssetId: "",
      editedFieldId: "",
      colors: ASSET_COLORS,
      icons: ASSET_ICONS,
      specialCharactersRule: [
        (value) =>
          /^[\w\s]+$/.test(value) ||
          "Alphabets, numeric and space are only allowed",
      ],
      maxCustomAssetTypesLimit: 5,
      labelType: `${LABELS.asset} Types`,
    };
  },
  computed: {
    systemAssetTypes() {
      let systemAssetTypes = [];
      systemAssetTypes = this.assetTypes.filter((assetType) => {
        return assetType.isSystem;
      });
      this.defaultList.forEach((assetType) => {
        let status = false;
        systemAssetTypes.some((sa) => {
          if (sa.assetTypeId !== assetType.id) {
            status = true;
          }
        });
        if (status) {
          assetType.isActive = false;
          systemAssetTypes.push(assetType);
        }
      });
      return systemAssetTypes;
    },
    customAssetTypes() {
      let customAssetTypes = [];
      customAssetTypes = this.assetTypes.filter((assetType) => {
        return !assetType.isSystem;
      });
      while (customAssetTypes.length < 10) {
        const assetType = {
          assetTypeId: uuidV4(),
          name: `Custom ${LABELS.asset} Type`,
          icon: "star",
          color: "#000000",
          isActive: false,
          isSystem: false,
        };
        customAssetTypes.push(assetType);
      }
      return customAssetTypes;
    },
    customAssetFields() {
      let customFields = [];
      customFields.push(...this.assetCustomFields);
      while (customFields.length < 10) {
        const field = {
          name: "Custom Field",
          isActive: false,
          id: uuidV4(),
        };
        customFields.push(field);
      }
      return customFields;
    },
  },
  methods: {
    toggleState(item, isAssetType) {
      console.info("This feature is not fully flushed out");
      // console.log(item);
      if (isAssetType) {
        console.log("Save the full asset type again");
        if (!this.hasMaxCustomTypesLimit()) {
          console.log("return DO NOT save toggle");
        } else {
          console.log("save toggle");
        }
      } else {
        console.log("Save the custom field");
      }
    },
    toggleEdit(item) {
      console.info("This feature is not fully flushed out");
      // console.log(item);
      this.editedAssetId = item.id;
    },
    toggleEditCustomAsset(item) {
      console.info("This feature is not fully flushed out");
      // console.log(item);
      this.editedCustomAssetId = item.assetTypeId;
    },
    toggleEditField(item) {
      console.info("This feature is not fully flushed out");
      // console.log(item);
      this.editedFieldId = item.id;
    },
    toggleSave(item) {
      console.info("This feature is not fully flushed out");
      // console.log(item);
      this.editedAssetId = "";
      this.editedCustomAssetId = "";
      this.editedFieldId = "";
    },
    toggleClose() {
      console.info("This feature is not fully flushed out");
      this.editedAssetId = "";
      this.editedCustomAssetId = "";
      this.editedFieldId = "";
    },
    hasMaxCustomTypesLimit() {
      console.log("hasMaxCustomTypesLimit");
      let activeCustomAssetTypes = [];
      activeCustomAssetTypes = this.assetTypes.filter((assetType) => {
        return !assetType.isSystem && assetType.isActive;
      });
      console.log(activeCustomAssetTypes.length);
      return activeCustomAssetTypes.length < this.maxCustomAssetTypesLimit;
    },
    getDisplayIcon(item) {
      return require(`@/assets/images/icons/assetManagement/${item.fileName}.png`);
    },
  },
};
</script>

<style scoped>
.hyp-table-container {
  width: 1200px;
}
.details-heading {
  font-size: 18px;
  font-weight: bold;
}
.section-heading {
  font-size: 18px;
}
.content-container {
  max-width: 550px !important;
}
</style>
